var _circle, _rect, _rect2, _rect3, _rect4, _g, _circle2, _g2, _g3, _g4, _g5, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.91748,
    cy: 17.5635,
    r: 1.1084,
    fill: "url(#paint0_radial_750_61)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.82227,
    y: 13.8574,
    width: 4.23828,
    height: 4.19922,
    rx: 1.25,
    fill: "url(#paint1_linear_750_61)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.82227,
    y: 13.8574,
    width: 4.23828,
    height: 4.19922,
    rx: 1.25,
    fill: "url(#paint2_linear_750_61)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.82227,
    y: 13.8574,
    width: 4.23828,
    height: 4.19922,
    rx: 1.25,
    fill: "url(#paint3_radial_750_61)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.82227,
    y: 13.8574,
    width: 4.23828,
    height: 4.19922,
    rx: 1.25,
    fill: "url(#paint4_linear_750_61)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_750_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85455 14.3554C9.86637 14.3555 9.87766 14.3555 9.8884 14.3555C10.2354 14.3539 11.0346 14.3405 11.355 14.2822C11.6987 14.2197 11.7431 14.0484 11.8042 13.7793C12.1807 12.1209 12.812 11.4834 13.2343 11.0568C13.2994 10.991 13.3596 10.9303 13.4131 10.8716C13.5964 10.6704 13.755 10.4933 13.8762 10.3566C14.7879 9.38891 15.3467 8.08498 15.3467 6.65054C15.3467 3.66529 12.9267 1.24527 9.94141 1.24527C6.95616 1.24527 4.53613 3.66529 4.53613 6.65054C4.53613 8.06749 5.08135 9.35711 5.97343 10.321C6.09798 10.462 6.26841 10.6525 6.46799 10.8716C6.5027 10.9097 6.54022 10.9487 6.5801 10.9893C6.60166 11.0113 6.6239 11.0337 6.64675 11.0568C7.06909 11.4834 7.70037 12.1209 8.07688 13.7793C8.13797 14.0484 8.18235 14.2197 8.5261 14.2822C8.84573 14.3404 9.49268 14.3537 9.82004 14.3553C9.83078 14.3553 9.8423 14.3555 9.85455 14.3554Z",
    fill: "url(#paint5_radial_750_61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85455 14.3554C9.86637 14.3555 9.87766 14.3555 9.8884 14.3555C10.2354 14.3539 11.0346 14.3405 11.355 14.2822C11.6987 14.2197 11.7431 14.0484 11.8042 13.7793C12.1807 12.1209 12.812 11.4834 13.2343 11.0568C13.2994 10.991 13.3596 10.9303 13.4131 10.8716C13.5964 10.6704 13.755 10.4933 13.8762 10.3566C14.7879 9.38891 15.3467 8.08498 15.3467 6.65054C15.3467 3.66529 12.9267 1.24527 9.94141 1.24527C6.95616 1.24527 4.53613 3.66529 4.53613 6.65054C4.53613 8.06749 5.08135 9.35711 5.97343 10.321C6.09798 10.462 6.26841 10.6525 6.46799 10.8716C6.5027 10.9097 6.54022 10.9487 6.5801 10.9893C6.60166 11.0113 6.6239 11.0337 6.64675 11.0568C7.06909 11.4834 7.70037 12.1209 8.07688 13.7793C8.13797 14.0484 8.18235 14.2197 8.5261 14.2822C8.84573 14.3404 9.49268 14.3537 9.82004 14.3553C9.83078 14.3553 9.8423 14.3555 9.85455 14.3554Z",
    fill: "url(#paint6_radial_750_61)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9136,
    cy: 4.3457,
    r: 2.08008,
    fill: "url(#paint7_linear_750_61)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_750_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6741 14.354C9.65217 12.9964 9.54401 12.1024 9.37931 11.4801C9.18949 10.7629 8.92396 10.4054 8.64307 10.122L8.63953 10.1184L8.63587 10.115C8.27608 9.77459 8.05225 9.29356 8.05225 8.75977C8.05225 7.72963 8.88733 6.89453 9.91748 6.89453C10.9476 6.89453 11.7827 7.72963 11.7827 8.75977C11.7827 9.29356 11.5589 9.77459 11.1991 10.115L11.1954 10.1184L11.1919 10.122C10.916 10.4004 10.6469 10.7343 10.4548 11.4456C10.2886 12.061 10.1799 12.9581 10.1583 14.3526C10.3467 14.3496 10.5722 14.3438 10.7837 14.3335C10.806 12.9786 10.9123 12.1487 11.0582 11.6086C11.2163 11.0234 11.4194 10.7807 11.6324 10.5654C12.1096 10.112 12.4077 9.47047 12.4077 8.75977C12.4077 7.38445 11.2928 6.26953 9.91748 6.26953C8.54215 6.26953 7.42725 7.38445 7.42725 8.75977C7.42725 9.47045 7.72537 10.112 8.20249 10.5653C8.41059 10.7759 8.61602 11.0389 8.77512 11.64C8.92046 12.1892 9.02598 13.0175 9.04867 14.3339C9.26513 14.3459 9.49337 14.3516 9.6741 14.354Z",
    fill: "#FFAD55"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_750_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5493 14.2116C10.5493 11.2297 11.0062 10.7541 11.4964 10.2595C11.916 9.86254 12.1777 9.30047 12.1777 8.67728C12.1777 7.47455 11.2027 6.49954 10 6.49954C8.79726 6.49954 7.82227 7.47455 7.82227 8.67728C7.82227 9.30047 8.08405 9.86254 8.50363 10.2595C8.99376 10.7541 9.44824 11.6101 9.44824 14.2116",
    stroke: "url(#paint8_linear_750_61)",
    strokeWidth: 0.25
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_750_61)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.76855,
    y: 15.7018,
    width: 4.25698,
    height: 0.668983,
    rx: 0.334491,
    transform: "rotate(-8.90494 7.76855 15.7018)",
    fill: "#7E6693"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_750_61)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.76855,
    y: 17.1838,
    width: 4.25698,
    height: 0.668983,
    rx: 0.334491,
    transform: "rotate(-8.90494 7.76855 17.1838)",
    fill: "#7E6693"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30273,
    y: 17.1644,
    width: 5.20018,
    height: 0.688634,
    rx: 0.344317,
    transform: "rotate(-8.90494 7.30273 17.1644)",
    fill: "url(#paint9_linear_750_61)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30273,
    y: 17.1644,
    width: 5.20018,
    height: 0.688634,
    rx: 0.344317,
    transform: "rotate(-8.90494 7.30273 17.1644)",
    fill: "url(#paint10_linear_750_61)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30273,
    y: 17.1644,
    width: 5.20018,
    height: 0.688634,
    rx: 0.344317,
    transform: "rotate(-8.90494 7.30273 17.1644)",
    fill: "url(#paint11_linear_750_61)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30273,
    y: 17.1644,
    width: 5.20018,
    height: 0.688634,
    rx: 0.344317,
    transform: "rotate(-8.90494 7.30273 17.1644)",
    fill: "url(#paint12_radial_750_61)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30273,
    y: 15.679,
    width: 5.20018,
    height: 0.688635,
    rx: 0.344317,
    transform: "rotate(-8.90493 7.30273 15.679)",
    fill: "url(#paint13_linear_750_61)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30273,
    y: 15.679,
    width: 5.20018,
    height: 0.688635,
    rx: 0.344317,
    transform: "rotate(-8.90493 7.30273 15.679)",
    fill: "url(#paint14_linear_750_61)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30273,
    y: 15.679,
    width: 5.20018,
    height: 0.688635,
    rx: 0.344317,
    transform: "rotate(-8.90493 7.30273 15.679)",
    fill: "url(#paint15_linear_750_61)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30273,
    y: 15.679,
    width: 5.20018,
    height: 0.688635,
    rx: 0.344317,
    transform: "rotate(-8.90493 7.30273 15.679)",
    fill: "url(#paint16_radial_750_61)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_750_61",
    x: 4.53613,
    y: 1.24527,
    width: 11.0605,
    height: 13.2602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.666667 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_750_61"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_750_61",
    x: 7.42725,
    y: 6.26953,
    width: 5.23047,
    height: 8.08444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.572549 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_750_61"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_750_61",
    x: 7.44727,
    y: 6.12454,
    width: 5.10547,
    height: 8.33707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_750_61"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_750_61",
    x: 7.56641,
    y: 14.8405,
    width: 4.71387,
    height: 1.72449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_750_61"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_750_61",
    x: 7.56641,
    y: 16.3225,
    width: 4.71387,
    height: 1.72449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_750_61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_750_61",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2104 18.1934) rotate(96.6544) scale(0.589912 1.36634)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.267752,
    stopColor: "#AC90C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6AAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_750_61",
    x1: 12.0605,
    y1: 16.1259,
    x2: 7.82227,
    y2: 16.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#947C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_750_61",
    x1: 7.61301,
    y1: 16.4453,
    x2: 8.64817,
    y2: 16.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A7B88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_750_61",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8154 14.1502) rotate(88.6361) scale(0.515543 2.29526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.228769,
    stopColor: "#EDE2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8BCCB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_750_61",
    x1: 10.9138,
    y1: 18.0566,
    x2: 10.9138,
    y2: 17.2656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5F9E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_750_61",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2224 5.07813) rotate(138.066) scale(6.19606 5.10921)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286168,
    stopColor: "#FFEC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_750_61",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8083 8.39845) rotate(-147.604) scale(9.11371 8.76613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.622387,
    stopColor: "#FFB239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_750_61",
    x1: 10.1861,
    y1: 5.01713,
    x2: 12.3246,
    y2: 3.35081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594121,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_750_61",
    x1: 12.3248,
    y1: 6.87334,
    x2: 9.82142,
    y2: 12.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_750_61",
    x1: 9.83988,
    y1: 17.1702,
    x2: 9.889,
    y2: 17.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_750_61",
    x1: 10.4468,
    y1: 17.8386,
    x2: 10.4452,
    y2: 17.3441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A68A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC2E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_750_61",
    x1: 7.24171,
    y1: 17.5539,
    x2: 8.98375,
    y2: 17.4611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#958387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#958387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_750_61",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6129 17.3995) rotate(90.3213) scale(0.523441 3.0982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126697,
    stopColor: "#FCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C9E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_750_61",
    x1: 9.83988,
    y1: 15.6848,
    x2: 9.889,
    y2: 16.4438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_750_61",
    x1: 10.4468,
    y1: 16.3533,
    x2: 10.4452,
    y2: 15.8588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A68A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC2E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_750_61",
    x1: 7.24171,
    y1: 16.0685,
    x2: 8.98375,
    y2: 15.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#958387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#958387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_750_61",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6129 15.9142) rotate(90.3213) scale(0.523441 3.0982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126697,
    stopColor: "#FCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C9E3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/lightBulb.8481fb82768bd572ab657cbdac923ad7.svg";
export { ForwardRef as ReactComponent };